import React, { Component, PropTypes } from 'react'
import Styles from './Program.css'
import Program from './Program'

class WrappedProgram extends Component {

  render () {
    let { title, ...program } = this.props
    return (
      <div className={`${Styles['splash-page']} ${Styles['gray-backgrond']}`}>
        <div className='splash-box'>
          <div className={Styles['splash-content']}>
            <div className={Styles['wrapped-program']}>
              <h3 style={{color: '#000000'}} className='text-center bottom40 font-weight-300'>
                {title}
              </h3>
              <Program {...program} isAccordionEnabled={this.props.isAccordionEnabled} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

WrappedProgram.propTypes = {
  title: PropTypes.string.isRequired,
  isAccordionEnabled: PropTypes.bool,
  spendingAmount: PropTypes.number.isRequired,
  pointFromSpendingAmount: PropTypes.func.isRequired,
  newMemberPoint: PropTypes.number.isRequired,
  setSpendingAmount: PropTypes.func.isRequired,
  setPointFromSpendingAmount: PropTypes.func.isRequired,
  sentValidationCode: PropTypes.bool.isRequired,
  toggleSentValidationCode: PropTypes.func.isRequired,
  showReview: PropTypes.func.isRequired
}

export default WrappedProgram



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/WrappedProgram.js